import React from 'react';
import { Menu, ShieldCheck } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';

interface HeaderProps {
  toggleSidebar: () => void;
  isSidebarCollapsed: boolean;
}

const roleBadge = {
  admin:        { label: 'ADMIN',        cls: 'bg-violet-500/12 border-violet-500/25 text-violet-300', avatar: 'from-violet-600 to-indigo-700' },
  distribuidor: { label: 'DISTRIBUIDOR', cls: 'bg-emerald-500/12 border-emerald-500/25 text-emerald-300', avatar: 'from-emerald-600 to-teal-700' },
  reseller:     { label: 'VENDEDOR',     cls: 'bg-blue-500/12 border-blue-500/25 text-blue-300',   avatar: 'from-blue-600 to-cyan-700' },
};

export default function Header({ toggleSidebar }: HeaderProps) {
  const { user } = useAuth();
  const badge = roleBadge[user?.role as keyof typeof roleBadge] ?? roleBadge.reseller;
  const initials = (user?.full_name || user?.email || 'A').slice(0, 2).toUpperCase();

  return (
    <header
      className="h-14 flex items-center justify-between px-3 sm:px-5 shrink-0 relative border-b border-white/[0.06]"
      style={{
        background: 'rgba(15, 23, 41, 0.55)',
        backdropFilter: 'blur(14px)',
        WebkitBackdropFilter: 'blur(14px)',
      }}
    >
      {/* Toggle sidebar */}
      <button
        onClick={toggleSidebar}
        className="p-2 rounded-lg text-white/55 hover:text-white/85 hover:bg-white/[0.08] transition-all active:scale-95"
        aria-label="Alternar menú lateral"
      >
        <Menu size={19} />
      </button>

      {/* Right: usuario */}
      <div className="flex items-center gap-2 sm:gap-3">
        {/* Badge de rol */}
        <span className={`hidden sm:flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[10px] font-semibold tracking-wide border ${badge.cls}`}>
          <ShieldCheck size={11} />
          {badge.label}
        </span>

        {/* Separador */}
        <div className="w-px h-4 sm:h-5 bg-white/[0.15]" />

        {/* Avatar + nombre */}
        <div className="flex items-center gap-2 sm:gap-2.5">
          <div className="relative shrink-0">
            <div className={`w-7 h-7 sm:w-8 sm:h-8 rounded-full flex items-center justify-center text-white text-[10px] sm:text-[11px] font-bold bg-gradient-to-br ${badge.avatar} ring-1 ring-white/10`}>
              {initials}
            </div>
            <span className="absolute -bottom-0.5 -right-0.5 w-2.5 h-2.5 rounded-full bg-emerald-400 border-2 border-[#0f1729]" />
          </div>
          <div className="text-right flex flex-col justify-center">
            <p className="text-[12px] sm:text-[13px] font-medium text-white/90 leading-none sm:leading-tight max-w-[90px] sm:max-w-none truncate">
              {user?.full_name || user?.email?.split('@')[0] || 'Usuario'}
            </p>
            <span className="sm:hidden text-[9px] font-semibold tracking-wide text-white/40 mt-0.5 uppercase">
              {badge.label.toLowerCase()}
            </span>
            <p className="hidden sm:block text-[10px] text-white/50 leading-tight truncate max-w-[160px] mt-0.5">
              {user?.email}
            </p>
          </div>
        </div>
      </div>
    </header>
  );
}